import { createAction } from '../../libs/saga-utils';

const ns = 'preferences';

export const PREFERENCES_TYPES = {
  SET_PREFERENCE: `${ns}/SET_PREFERENCE`,
  RESET: `${ns}/RESET`
};

export const PREFERENCES_ACTIONS = {
  setPreference: createAction(
    PREFERENCES_TYPES.SET_PREFERENCE,
    (key, value) => ({ key, value })
  ),
  reset: createAction(PREFERENCES_TYPES.RESET)
};
